"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AuthException_1 = __importDefault(require("../../../../Exception/AuthException"));
const asyncIterate_1 = __importDefault(require("../../../../Util/asyncIterate"));
class UserModel {
    constructor(cache) {
        this.getUserByToken = async (token) => {
            const tokens = (await this.cache
                .getObject(UserModel.TOKEN_TO_USER_ID_DB)
                .asPromise());
            const id = tokens[token];
            if (id === undefined) {
                throw new AuthException_1.default();
            }
            return this.getUserById(id);
        };
        this.userKey = (id) => `${UserModel.USER_DB}.${id}`;
        this.userLoginToIdKey = (login) => `${UserModel.USER_DB}.${login}`;
        this.putUser = async (user) => {
            await this.cache.setObject(this.userKey(user.id), user).asPromise();
            await this.cache
                .setString(this.userLoginToIdKey(user.login), user.id)
                .asPromise();
        };
        this.getUserById = async (id) => (await this.cache.getObject(this.userKey(id)).asPromise());
        this.getUserByEmail = async (email) => {
            const id = (await this.cache
                .getString(this.userLoginToIdKey(email))
                .withDefault(null)
                .asPromise());
            if (id === null) {
                throw new AuthException_1.default();
            }
            return (await this.cache.getObject(this.userKey(id)).asPromise());
        };
        this.getTokenByRefreshToken = async (refreshToken) => {
            const tokens = await this.cache
                .getObject(UserModel.REFRESH_TOKEN_TO_TOKEN_DB)
                .withDefault({})
                .asPromise();
            const token = tokens[refreshToken];
            if (token === undefined) {
                throw new AuthException_1.default();
            }
            return token;
        };
        this.addToken = async (token, refreshToken, userId) => {
            const tokens = (await this.cache
                .getObject(UserModel.TOKEN_TO_USER_ID_DB)
                .asPromise());
            tokens[token] = userId;
            await this.cache
                .setObject(UserModel.TOKEN_TO_USER_ID_DB, tokens)
                .asPromise();
            const refreshTokens = (await this.cache
                .getObject(UserModel.REFRESH_TOKEN_TO_TOKEN_DB)
                .asPromise());
            refreshTokens[refreshToken] = token;
            await this.cache
                .setObject(UserModel.REFRESH_TOKEN_TO_TOKEN_DB, refreshTokens)
                .asPromise();
        };
        this.setUsers = async (usersList) => {
            await this.cache
                .setArray(UserModel.IDS_LIST, usersList.map((u) => u.id))
                .asPromise();
            await (0, asyncIterate_1.default)(usersList, async (user) => {
                await this.putUser(user);
            });
        };
        this.all = async () => {
            return (0, asyncIterate_1.default)((await this.cache.getArray(UserModel.IDS_LIST).asPromise()), this.getUserById);
        };
        this.cache = cache;
    }
}
UserModel.REFRESH_TOKEN_TO_TOKEN_DB = "Mock.Database.REFRESH_TOKEN_TO_TOKEN_DB";
UserModel.USER_DB = "Mock.Database.USER_DB";
UserModel.TOKEN_TO_USER_ID_DB = "Mock.Database.TOKEN_TO_USER_ID_DB";
UserModel.IDS_LIST = "Mock.Database.IDS_LIST";
exports.default = UserModel;
//# sourceMappingURL=UserModel.js.map